<template>
    <div class="comp_modal_conflict_filters">
        <!-- CONFLICT MODAL FILTERS -->
        <div
            class="modal_overlay"
            v-bind:class="{ modalShow: is_visible_modal_conflict }"
        >
            <div class="box">
                <header>
                    <h2 class="modal_title">
                        {{ translations.conflict_filters.title }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <p class="content">
                        {{ translations.conflict_filters.content }}
                    </p>
                    <span
                        class="icon-close-positive-circle close"
                        @click="closeModal"
                    ></span>
                </section>
            </div>
        </div>
        <!-- /CONFLICT MODAL FILTERS -->
    </div>
</template>

<script>
import App from './../application.js'

export default {
    data: function () {
        return {
            obj_content: {},
            is_visible_modal_conflict: false,
            translations: {
                generic: App.current_translations['generic'],
                conflict_filters: App.current_translations['conflict_filters']
            }
        }
    },
    mounted: function () {
        var self = this;
        App.bus.$on('conflictFilters', function (obj) {
            self.is_visible_modal_conflict = true;
        });
    },
    methods: {
        closeModal: function () {
            this.is_visible_modal_conflict = false;
        }
    }
}
</script>

<style>
</style>